import { get } from 'lodash';

export const getState = (state, param = null, defaultValue = null) => get(state, `deliveryNote.return.list${(param ? `.${param}` : '')}`, defaultValue);
